/**
 * A generic validation result for reference numbers in Habil+
 */
interface ReferenceNumberValidationResult {
    isValid: boolean;
    errors: string[];
};

function createReferenceNumberValidationResult(isValid: boolean, errors?: string[]): ReferenceNumberValidationResult {
    return {
        isValid: isValid,
        errors: errors ?? [],
    };
};

export {
    createReferenceNumberValidationResult,
    ReferenceNumberValidationResult,
}
